import { Component, OnInit, Injector } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { HelperUtilityService } from 'src/app/services/helper-utility.service';
import { PDLService } from 'src/app/services/pdl-service.service';
import { isNullOrUndefined } from 'src/app/services/utils';
import { COMMON_CONSTANTS, LINE_IDENTIFIER, MANAGE_LINE_CONST, ANALYTICS, ENTITLEMENT_ACTIVITYNAMES } from '../../../common/core/common.constants';
import { BulkRequestsForLineIdentifier, RequestForLineidentifier, RequestsBulkLineIdentifier } from '../../../common/models/data.model';
import { ContentService } from 'src/app/services/content.service';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { UtilsService } from 'src/app/services/utils.service';
import { SuccessComponent } from '../success/success.component';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-line-identifier',
  templateUrl: './line-identifier.component.html',
  styleUrls: ['./line-identifier.component.scss'],
})
export class LineIdentifierComponent implements OnInit {

  authoringContentData: any;
  selectedLines: any;
  lineIdentifierLines: any = [];
  configResponse: any;
  selectedUniqueUDF: any = [];
  configModel: any = [];
  configModelOriginal: any = [];
  configurationValue: any;
  submitEnabled = false;
  isSingleLine = true;
  authInfo: any;
  userId: any;
  showTechnicalIssuePopup: boolean;
  showLineIdentifierPopup: boolean = true;
  isLineDetailsWindow: boolean;
  ngbModalOptions: NgbModalOptions;
  errHeader:any;
  errBody: any;
  issubmitReadOnly: boolean;
  manageLineService: ManageLineService;
  _cacheSvc: HttpCacheService;
  utilsSvc: UtilsService;
  _loaderSvc: LoaderService;
  modalService: NgbModal;
  contentService: ContentService;
  _helperUtilSvc: HelperUtilityService;
  pdlService: PDLService
  enableCupNoRegrets = environment.ENABLE_CUP_NOREGRETS_UDF
  enableDHudf = environment.ENABLE_DH_UDF;
  isSearchVisible = false;
  maxLengthOfUdf: any;
  udf6FilterData: any = [];
  searchUdfText: string = "";
  isEndUser: boolean;
  isUdfAhub2Enabled: boolean;

  constructor(private injector : Injector) {
    this.manageLineService = this.injector.get<ManageLineService>(ManageLineService);
    this._cacheSvc = this.injector.get<HttpCacheService>(HttpCacheService);
    this.utilsSvc = this.injector.get<UtilsService>(UtilsService);
    this._loaderSvc = this.injector.get<LoaderService>(LoaderService);
    this.modalService = this.injector.get<NgbModal>(NgbModal);
    this.contentService = this.injector.get<ContentService>(ContentService);
    this._helperUtilSvc = this.injector.get<HelperUtilityService>(HelperUtilityService);
    this.pdlService = this.injector.get<PDLService>(PDLService);
    this.isLineDetailsWindow = false;
  }

  ngOnInit() {
    this.isEndUser = this.utilsSvc.IsEndUser();
    this.authoringContentData = this.utilsSvc.getContentDataFromSession() ? this.utilsSvc.getContentDataFromSession().lineIdentifierAuthoring : {};
    this.userId = this._helperUtilSvc.getUserId();
    this.errHeader = '';
    this.errBody = '';
    this.isUdfAhub2Enabled = environment.ENABLE_UDF_AHUB_2;

    if (!isNullOrUndefined(this.selectedLines) && this.selectedLines.length > COMMON_CONSTANTS.DIGITS.ZERO) {
      if (this.selectedLines.length === COMMON_CONSTANTS.DIGITS.ONE) {
        this.isSingleLine = true;
      } else {
        this.isSingleLine = false;
      }
      for (const line of this.selectedLines) {
        line.expandFlagValue = true;
        line.successValidator = false;
        if(this.isEndUser){
          line.productType = line.productType?.code;
        }
        this.lineIdentifierLines.push(line);
      }
    }

    if (this.isSingleLine) {
      this.issubmitReadOnly = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.LINE_IDENTIFIER);
    } else {
      this.issubmitReadOnly = this.utilsSvc.isReadOnly_AhubCare_UserActivity(ENTITLEMENT_ACTIVITYNAMES.LINE_IDENTIFIER_BULK);
    }

    if(this.enableDHudf){
      this.maxLengthOfUdf = COMMON_CONSTANTS.DIGITS.FORTY;
        this.udf6FilterData = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.TEA_RESPONSE))?.banInfo?.bundleIdList;
    }

    this.configModel = this.utilsSvc.createConfigModel();
    this.getFilteredData(_.cloneDeep(this.configModel));

    ContentService.SetCache(LINE_IDENTIFIER.CACHED_LINE_IDENTIFIER_LINES, JSON.stringify(this.lineIdentifierLines));
    this._loaderSvc.stop();
    this.pdlService.ifEnabledGenerateModalViewTag({
      eventAction: ANALYTICS.LOAD,
      modalName: ANALYTICS.UPDATE_LINE_IDENTIFIER
    });
  }

  getFilteredData(configurationModel) {

    if (!isNullOrUndefined(this.lineIdentifierLines) &&
      !isNullOrUndefined(configurationModel)) {

      this.lineIdentifierLines.forEach((mobileNumber) => {
        if (!isNullOrUndefined(mobileNumber)) {
          const keys = Object.keys(mobileNumber.lineIdentifier);
          keys.forEach((key) => {
            configurationModel.forEach((config) => {
              this.getValidConfigVals(key, config, mobileNumber);
            });
          });
          mobileNumber.configModel = _.cloneDeep(configurationModel);
          configurationModel = _.cloneDeep(this.configModel);
        }
      });

    }
  }

  getValidConfigVals(key, config, mobileNumber){
    let validKeyUDF, validConfigNameUDFID: number;
    if (this.enableCupNoRegrets && this.enableDHudf) {
      validKeyUDF = LINE_IDENTIFIER.UDF_KEYS_DH_CUP.indexOf(key);
      validConfigNameUDFID = LINE_IDENTIFIER.UDFID_KEYS_CUP_DH.indexOf(config.configName);
    } else if (this.enableCupNoRegrets  && !this.enableDHudf) {
      validKeyUDF = LINE_IDENTIFIER.UDF_KEYS_CUP_NO_REGRETS.indexOf(key);
      validConfigNameUDFID = LINE_IDENTIFIER.UDFID_KEYS_CUP_NO_REGRETS.indexOf(config.configName);
    } else if (!this.enableCupNoRegrets  && this.enableDHudf) {
      validKeyUDF = LINE_IDENTIFIER.UDF_KEYS_DH.indexOf(key);
      validConfigNameUDFID = LINE_IDENTIFIER.UDFID_KEYS_DH.indexOf(config.configName);
    } else {
      validKeyUDF = LINE_IDENTIFIER.UDF_KEYS.indexOf(key);
      validConfigNameUDFID = LINE_IDENTIFIER.UDFID_KEYS.indexOf(config.configName);
    }
    this.checkForKeys(key, validKeyUDF, validConfigNameUDFID, config, mobileNumber);
  }

  onClickSearchIcon() {
    this.isSearchVisible = true;
  }
  onClickCloseIcon() {
    this.isSearchVisible = false;
    this.searchUdfText = COMMON_CONSTANTS.STRING_EMPTY;
  }

  checkForKeys(key, validKeyUDF, validConfigNameUDFID, config, mobileNumber){
    if (!isNullOrUndefined(key) && validKeyUDF > -1 && validConfigNameUDFID > -1 && validKeyUDF === validConfigNameUDFID) {
      config[LINE_IDENTIFIER.CONFIG_VALUE] = !isNullOrUndefined(mobileNumber.lineIdentifier[key]) ? mobileNumber.lineIdentifier[key] : COMMON_CONSTANTS.STRING_EMPTY;
    }
  }

  onClear(line){
    line.configModel?.forEach((config) => {
      if(config?.key === LINE_IDENTIFIER.CONFIG_UDF6){
        config.configValue = "";
      }
    });
    this.onChangeInput(line);
  }

  onChangeInput(line) {
    const cachedLines = JSON.parse(ContentService.GetCache(LINE_IDENTIFIER.CACHED_LINE_IDENTIFIER_LINES));
    const tempLine = cachedLines.find((cachedLine) => line.msisdn === cachedLine.msisdn);
    if (_.isEqual(line.configModel, tempLine.configModel)) {
      line.successValidator = false;
    } else {
      line.successValidator = true ; // true if something changes
    }
    const linesWithSuccess = this.lineIdentifierLines.find((eachLine) => eachLine.successValidator === true);
    if (linesWithSuccess) {
      this.submitEnabled = true;
    } else {
      this.submitEnabled = false;
    }
  }

  omit_special_char(event) {
    const k = event.keyCode;
    return !(k == 93  || k == 91 || k == 39 || k == 34 || k == 123 || k == 125 || k == 60 || k == 62 || k == 43 || k == 42 || k == 61 || k == 37 || k == 94 );
  }

  setValueOrEmptyIfNullOrUndefined(value) {
    if (!isNullOrUndefined(value)) {
      return value;
    }
    return '';
  }

  updateLineIdentifier() {
    this.authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
    const udfObject = new RequestForLineidentifier();
    udfObject.msisdn = this.setValueOrEmptyIfNullOrUndefined(this.lineIdentifierLines[COMMON_CONSTANTS.DIGITS.ZERO].msisdn);
    udfObject.ban = this.setValueOrEmptyIfNullOrUndefined(sessionStorage.getItem(COMMON_CONSTANTS.BAN_NUMBER_KEY));

    this.lineIdentifierLines[COMMON_CONSTANTS.DIGITS.ZERO]?.configModel?.forEach((config) => {
      this.updateUdfObject(config, udfObject);
    });

    const reqPayload = this.buildRequestPayload(udfObject);

    this.manageLineService.updateLineIdentifier(reqPayload).subscribe(
      (response) => this.handleUpdateLineIdentifierSuccess(response),
      (err) => this.errorThrown(err)
    );

    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: ANALYTICS.SUBMIT_CHANGE,
      assetType: ANALYTICS.BUTTON,
      modalName: ANALYTICS.UPDATE_LINE_IDENTIFIER,
    });
  }

  updateUdfObject(config, udfObject) {
    switch (config.configName) {
      case LINE_IDENTIFIER.CONFIG_UDFID1:
      case LINE_IDENTIFIER.CONFIG_UDFID2:
      case LINE_IDENTIFIER.CONFIG_UDFID3:
      case LINE_IDENTIFIER.CONFIG_UDFID4:
      case LINE_IDENTIFIER.CONFIG_UDFID5:
        udfObject[`udf${config.configName.slice(-1)}`] = this.setValueOrEmptyIfNullOrUndefined(config.configValue);
        break;
      case LINE_IDENTIFIER.CONFIG_UDFID6:
        this.updateUdf6(config, udfObject);
        break;
    }
  }

  updateUdf6(config, udfObject) {
    if (this.enableDHudf && this.lineIdentifierLines[0].containsDHRatePlan && this.lineIdentifierLines[0].productType !== 'G') {
      udfObject.udf6 = this.setValueOrEmptyIfNullOrUndefined(config.configValue);
    }
  }

  buildRequestPayload(udfObject) {
    return {
      trace: {
        userId: this.userId,
      },
      logonId: !isNullOrUndefined(this.authInfo) ? this.authInfo.logonID : COMMON_CONSTANTS.LOGON_ID,
      emailId: !isNullOrUndefined(this.authInfo) ? this.authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID,
      orgId: this._helperUtilSvc.getOrgID(),
      msisdnDetails: [udfObject],
    };
  }

  handleUpdateLineIdentifierSuccess(response) {
    this._loaderSvc.stop();
    if (!isNullOrUndefined(response) && !isNullOrUndefined(response.status) && response.status === MANAGE_LINE_CONST.SUCCESS) {
      this.manageLineService.close();
      this.isLineDetailsWindow ? this.manageLineService.notifyLineDetailTransations.next(true) : this.manageLineService.notifyService.next(true);
      this.lineIdentifierSuccess(response.accountTransactionRefNum);
    } else {
      this.technicalErrorPopup();
    }
  }

  technicalErrorPopup(){
    this.ngbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: false,
      container: '#am-container-custom',
    };
    const lineIdentifierModalRef = this.modalService.open(LineIdentifierComponent, this.ngbModalOptions);
    lineIdentifierModalRef.componentInstance.showLineIdentifierPopup = false;
    lineIdentifierModalRef.componentInstance.showTechnicalIssuePopup = true;
  }
closeModal(){
  this.errHeader = '';
  this.errBody = '';
  this.manageLineService.close();
  this.pdlService.ifEnabledGenerateClickTag({
    type: ANALYTICS.CLICK_TO_NAVIGATE,
    action: ANALYTICS.CLICK,
    ctaName: ANALYTICS.CLOSE,
    assetType: ANALYTICS.BUTTON,
    modalName: ANALYTICS.UPDATE_LINE_IDENTIFIER
  });
}
  errorThrown(err) {
    this._loaderSvc.stop();
    this.utilsSvc.errorHandling(err);
  }

  updateLineIdentifierBulk() {
    if (!isNullOrUndefined(this.lineIdentifierLines) && !this.isSingleLine) {
      const bulkLineIdentifierRequestPayload = new BulkRequestsForLineIdentifier();
      bulkLineIdentifierRequestPayload.targetServiceName = LINE_IDENTIFIER.TARGET_SERVICE_NAME;
      bulkLineIdentifierRequestPayload.ban = this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.BAN);
      this.authInfo = JSON.parse(this._cacheSvc.getFromSessionStorage(MANAGE_LINE_CONST.AUTHENTICATION_INFO));
      this.lineIdentifierLines.forEach((line) => {
        const bulkJsonData = new RequestsBulkLineIdentifier();
        bulkJsonData.orgId = this._helperUtilSvc.getOrgID();
        bulkJsonData.logonId = !isNullOrUndefined(this.authInfo) ? this.authInfo.logonID : COMMON_CONSTANTS.LOGON_ID;
        bulkJsonData.email = !isNullOrUndefined(this.authInfo) ? this.authInfo.logonEmail : COMMON_CONSTANTS.LOGON_ID;
        bulkJsonData.msisdn = this.setValueOrEmptyIfNullOrUndefined(line.msisdn);
        bulkJsonData.userId = this.setValueOrEmptyIfNullOrUndefined(this.userId);
        bulkJsonData.ban = this.setValueOrEmptyIfNullOrUndefined(line.ban);
        line.configModel.forEach((config) => {
          if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID1) {
            bulkJsonData.uDFID1 = this.setValueOrEmptyIfNullOrUndefined(config.configValue);
          } else if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID2) {
            bulkJsonData.uDFID2 = this.setValueOrEmptyIfNullOrUndefined(config.configValue);
          } else if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID3) {
            bulkJsonData.uDFID3 = this.setValueOrEmptyIfNullOrUndefined(config.configValue);
          } else if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID4) {
            bulkJsonData.uDFID4 = this.setValueOrEmptyIfNullOrUndefined(config.configValue);
          } else if (config.configName === LINE_IDENTIFIER.CONFIG_UDFID5) {
            bulkJsonData.uDFID5 = this.setValueOrEmptyIfNullOrUndefined(config.configValue);
          } else if (this.enableDHudf && config.configName === LINE_IDENTIFIER.CONFIG_UDFID6 && line.containsDHRatePlan && line.productType !== 'G') {
            bulkJsonData.uDFID6 = this.setValueOrEmptyIfNullOrUndefined(config.configValue);
          }
        });
        bulkLineIdentifierRequestPayload.requests.push(bulkJsonData);
      });

      this.manageLineService.bulkLineIdentifierProcessor(bulkLineIdentifierRequestPayload).subscribe((response) => {
        this._loaderSvc.stop();
        if (!isNullOrUndefined(response) && !isNullOrUndefined(response.token) &&
          !isNullOrUndefined(response.status) && response.status === MANAGE_LINE_CONST.SUCCESS) {
          this.lineIdentifierSuccess(response.token);
        }
      }, (error) => {
        this.errorThrown(error);
      });
    }
  }

  lineIdentifierSuccess(token) {
    this.ngbModalOptions = {
      container: '#am-container-custom',
    };
    if (!isNullOrUndefined(token)) {
      this.manageLineService.close();
      const successModalRef = this.modalService.open(SuccessComponent, this.ngbModalOptions);
      successModalRef.componentInstance.modalBodyContent = !isNullOrUndefined(this.authoringContentData && this.authoringContentData.confirmationMsgTxt) ?
        this.authoringContentData.confirmationMsgTxt.replace('{{transaction}}', token) : '';
      successModalRef.componentInstance.header = !isNullOrUndefined(this.authoringContentData && this.authoringContentData.lineIdentifierSuccessTxt) ?
        this.authoringContentData.lineIdentifierSuccessTxt : '';
      successModalRef.componentInstance.isLineDetailsWindow = this.isLineDetailsWindow;
    }
  }

  expansionPanelClosed(line) {
    line.expandFlagValue = false;
  }

  expansionPanelOpened(line) {
    line.expandFlagValue = true;
  }
  onClickNext(line) {
    const length = this.lineIdentifierLines.length;
    line.expandFlagValue = false;
    const index = this.lineIdentifierLines.indexOf(line);
    if (index !== (length - COMMON_CONSTANTS.DIGITS.ONE)) {
      this.lineIdentifierLines[index + COMMON_CONSTANTS.DIGITS.ONE].expandFlagValue = true;
    }
  }

  removeNumber(line) {
    const index = this.lineIdentifierLines.indexOf(line);
    this.lineIdentifierLines.splice(index, 1);
    this.manageLineService.changeCurrentSelection(line);
    if (this.lineIdentifierLines.length === 0) {
      this.manageLineService.close();
    }
  }

}
